<template>
  <div class="l-side">
    <div class="l-side__header">
      <h1 class="l-side-logo">
        <a :href="appUrl" class="l-side-logo__link">
          <img
            src="@/assets/img/logo.png"
            :alt="$constants.siteName"
            class="l-side-logo__image"
          />
        </a>
      </h1>
      <div class="l-side__search">
        <label class="c-input-search">
          <i class="fas fa-search"></i>
          <Input v-model="search" placeholder="案件を検索" />
        </label>
      </div>
    </div>
    <div class="l-side__content">
      <div class="l-side__scroll" ref="scroll">
        <ListCompanyRoom v-if="isCompany" :search="search" />
        <ListInfluencerRoom v-else-if="isInfluencer" :search="search" />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input';
import ListCompanyRoom from '@/components/side/ListCompanyRoom';
import ListInfluencerRoom from '@/components/side/ListInfluencerRoom';
import utils from '@/utils';
import PerfectScrollbar from 'perfect-scrollbar';

export default {
  components: {
    Input,
    ListCompanyRoom,
    ListInfluencerRoom
  },
  data() {
    return {
      ps: null,
      search: ''
    };
  },
  computed: {
    appUrl() {
      return this.$constants.appUrl[this.role.name];
    },
    role() {
      return this.$store.state.role;
    },
    isCompany() {
      return utils.isCompany(this.role.name);
    },
    isInfluencer() {
      return utils.isInfluencer(this.role.name);
    }
  },
  mounted() {
    this.ps = new PerfectScrollbar(this.$refs.scroll, {
      minScrollbarLength: 20,
      suppressScrollX: true
    });
  },
  beforeDestroy() {
    this.ps.destroy();
    this.ps = null; // to make sure garbages are collected
  }
};
</script>
